import makeStyles from '@mui/styles/makeStyles'
import FormikControl from '../../molecules/FormikControl'
import { useFormik } from 'formik'
import { Button, Card, Paper } from '@mui/material'
import { setToken, loadUser } from '../../../store/userSlice'
import * as Yup from 'yup'
import { handleOpenAlert } from '../../../lib/handleAlert'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import logoRTG from '../../../images/logo_rtg_black.svg'
import { useParams } from 'react-router'
import cookies from 'js-cookie'
import axios from 'axios'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  nested: {
    padding: theme.spacing(10),
  },
  listItem: {
    color: theme.palette.white.main,
  },
  logo: {
    filter:
      'invert(18%) sepia(44%) saturate(1598%) hue-rotate(182deg) brightness(98%) contrast(84%);',
    maxWidth: '500px',
    width: '450px',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
    },
  },

  paperBack: {
    background: theme.palette.primary.light,
    position: 'absolute',
    minHeight: '650px',
    minWidth: '530px',
    margin: '0px 0px 50px 55px',
    maxWidth: '650px',
    maxHeight: '650px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  paperFront: {
    position: 'relative',
    maxWidth: '540px',
    maxHeight: '650px',
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },

  formBg: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '24px',
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
  },
  form: {
    height: '100%',
    width: '100%',
    maxWidth: '600px',
    maxHeight: '650px',
    display: 'flex',
    gap: '16px',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      maxWidth: 'unset',
    },
  },
  btn: {
    background: theme.palette.primary.main,
  },
}))

const DoctorRegister = () => {
  const classes = useStyles()
  const history = useHistory()
  const { code } = useParams()
  const dispatch = useDispatch()

  const formik = useFormik({
    initialValues: {
      password: '',
      passwordConfirmation: '',
      email: '',
      firstname: '',
      lastname: '',
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required('Pole wymagane')
        .min('8', 'Hasło musi zawierać minimum 8 znaków'),
      passwordConfirmation: Yup.string()
        .required('Pole wymagane')
        .oneOf(
          [Yup.ref('password'), null],
          'Hasło musi być takie samo w obu polach'
        )
        .min('8', 'Hasło musi zawierać minimum 8 znaków'),
    }),
    onSubmit: (values) => {
      axios
        .post('/api/doctor/auth/register', {
          code: decodeURIComponent(code),
          password: values.password,
        })
        .then(async (res) => {
          if (res.status == 200) {
            // eslint-disable-next-line
            axios.defaults.baseURL = `${process.env.REACT_APP_BASE_URL}/api/doctor`
            await dispatch(setToken(res.data.access_token))
            await dispatch(loadUser())
            cookies.set('x-role', 2)
            handleOpenAlert({
              title: 'Sukces!',
              subtitle: 'Witamy w systemie Smart RTG',
              type: 'success',
            })
            // history.push('/examinations')
          }
        })
        .catch((err) => console.log(err.response))
    },
  })

  useEffect(() => {
    if (code && formik) {
      checkValidate(code, formik)
    }
  }, [code])

  const checkValidate = (code, formik) => {
    axios
      .post('/api/doctor/auth/code/check', { code: decodeURIComponent(code) })
      .then((res) => {
        if (res.data) {
          formik.setFieldValue('firstname', res.data.firstname)
          formik.setFieldValue('lastname', res.data.lastname)
          formik.setFieldValue('email', res.data.email)
        }
      })
      .catch((err) => {
        if (err.request.status == 404) {
          history.push('/login')
        }
      })
  }

  return (
    <form className={classes.formBg} onSubmit={formik.handleSubmit}>
      <Paper className={classes.paperBack} elevation={3}></Paper>
      <Card className={classes.paperFront} sx={{ minWidth: 'unset' }}>
        <div className={classes.form}>
          <img className={classes.logo} src={logoRTG} alt="logo" />
          <div className="flex flex-wrap gap-4">
            <h1 className="text-left text-custom_blue_dark text-2xl">
              Rejestracja
            </h1>
            <div className=" flex gap-4 flex-col justify-center w-9/12 mx-auto">
              <FormikControl
                variableName="firstname"
                handleChange={formik.handleChange}
                labelName="Imię"
                formik={formik}
                disabled={true}
              />
              <FormikControl
                variableName="lastname"
                handleChange={formik.handleChange}
                labelName="Nazwisko"
                formik={formik}
                disabled={true}
              />
              <FormikControl
                variableName="email"
                handleChange={formik.handleChange}
                labelName="E-mail"
                formik={formik}
                disabled={true}
                type="email"
              />
              <FormikControl
                variableName="password"
                handleChange={formik.handleChange}
                labelName="Hasło"
                formik={formik}
                type="password"
                inputProps={{
                  autoComplete: 'new-password',
                }}
              />
              <FormikControl
                variableName="passwordConfirmation"
                handleChange={formik.handleChange}
                labelName="Powtórz hasło"
                formik={formik}
                type="password"
                inputProps={{
                  autoComplete: 'new-password',
                }}
              />
            </div>
          </div>
          <div className=" flex justify-end gap-8 flex-wrap sm:justify-center sm:gap-2">
            <Button
              className={classes.btn}
              color="primary"
              variant="contained"
              type="submit"
              size="large"
            >
              Zarejestruj się
            </Button>
          </div>
        </div>
      </Card>
    </form>
  )
}

export default DoctorRegister
